import { connect, ConnectedProps } from "react-redux";
import {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  deleteUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
} from "../../actions/actions";
import {
  getUserPassengerCallState,
  getUserPassengers,
  getUserSelectedTravelerId,
  getPremierCollectionBookSelectedAvailabilityCheckInMinimumAge,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { PremierCollectionBookPassengerSelection } from "./component";
import { getPremierCollectionShopCancellationSummary } from "../../../shop/reducer";
import { getIsTravelApp } from "../../../availability/reducer";
import { getFromDate } from "../../../search/reducer";

const mapStateToProps = (state: IStoreState) => ({
  travelers: getUserPassengers(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  userPassengerCallState: getUserPassengerCallState(state),
  cancellationSummary: getPremierCollectionShopCancellationSummary(state),
  isTravelApp: getIsTravelApp(state),
  minimumCheckInAge:
    getPremierCollectionBookSelectedAvailabilityCheckInMinimumAge(state),
  checkInDate: getFromDate(state),
});

const mapDispatchToProps = {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  deleteUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PremierCollectionBookPassengerSelectionConnectorProps =
  ConnectedProps<typeof connector>;

export const ConnectedPremierCollectionBookPassengerSelection = connector(
  PremierCollectionBookPassengerSelection,
);
